import { createSelector } from 'reselect';
import type { SessionState } from './session.reducer';
import type { Role } from '../../data/tisms-api';
import type { AuthState } from '../auth/auth.reducer';

const selectSession = (state: { session: SessionState }): SessionState => state.session;
const selectAuthRole = (state: { auth: AuthState }): Role | null => state.auth.role;

export const selectRoleId = createSelector([selectSession], (s) => s.roleId);
export const selectLang = createSelector([selectSession], (s) => s.lang);
export const selectIsBilingual = createSelector([selectSession], (s) => s.lang === 'ta');

/* The active role — the one auth stored at sign-in, built from the modules the
 * SERVER says this user has.
 *
 * This used to look the id up in a client-side list of invented personas, so
 * the sidebar was filtered by a role the user did not hold. */
export const selectActiveRole = createSelector(
  [selectAuthRole],
  (role): Role | null => role ?? null,
);

/** The modules the active role may see. */
export const selectActiveModules = createSelector(
  [selectActiveRole],
  (role): string[] => role?.modules ?? [],
);
